import { Component, OnInit, EventEmitter, Input, Output, HostListener, OnDestroy } from '@angular/core';
import { ViewService } from "../services/view.service"
import { ViewSummaryItem, View } from '../objects/ViewObject';
import { Globals } from '../objects/Globals';
import { MenuService } from "../services/menu.service";
import { Action } from "../objects/DetailObject";
import { WorkspaceService } from '../services/workspace.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.css']
})
export class ViewComponent implements OnInit, OnDestroy {
  private closeBtnClicked : boolean;
  private componentId:string;
  private viewList:ViewSummaryItem[];
  private systemViewList:ViewSummaryItem[];
  private userViewList:ViewSummaryItem[];
  private menuActions:Action[] = [];
  private previousComponentId:string;
  private sub: Subscription;
  showView :boolean = true;
  isUserHide: boolean = false;
  isStandardHide: boolean = false;
  system: string = "system";
  user: string = "user";
  menuId: string;
  menu:boolean = false;
  draggable:boolean = true;

  @Input() hidePanel: boolean = false;
  @Input() profileView: boolean = false;
  @Input() notFixedWidth:boolean = false;
  @Input() groupType: string;
  @Input() set setMenuId(menuId:string){
    this.menu = true;
    if (menuId){
      this.menuService.getMenuCardMenuActions(menuId).subscribe(result => {
        this.menuActions = JSON.parse(result);
      });
    }
  };
  @Input() set refreshView(refresh: any){
    this.getViewList();
  }
  @Input() set setComponentId(id: string){
    this.componentId = id;
    if (this.componentId){
      this.previousComponentId = this.componentId;
      this.viewService.getSystemViewList(this.componentId).subscribe(result=>{
        this.systemViewList = this.sortViewList(JSON.parse(result));
      });
  
      this.viewService.getUserViewList(this.componentId).subscribe(result => {
        this.userViewList = this.sortViewList(JSON.parse(result));
      });
    }
  }

  @Output() viewSelectedChanged = new EventEmitter<string>();
  @Output() menuSelectedChanged = new EventEmitter<string>();
  @Output() showSideBar = new EventEmitter<boolean>();
  clearUserView :boolean;
  clearSystemView :boolean;
  // showSideBar
  constructor(private viewService:ViewService, private globals:Globals, private view: View, private menuService:MenuService, private workspaceService:WorkspaceService) { 
    this.sub = this.viewService.refreshViewChanged$.subscribe(result => {
      if (result){
        if (this.groupType){
          this.viewService.createViewList(this.groupType).subscribe(result => {
            if (result){
              this.componentId = result;
              this.getViewList();
            }
          })
        }
        else{
          this.getViewList();
        }
      }
    })
  }

  // @HostListener('window:resize', ['$event'])
  // onResize(event) {
  //   if (event.target.innerWidth < 992) {
  //     this.showView = false;
  //   }
  //   else{
  //     if (!this.closeBtnClicked){
  //       this.showView = true;
  //     }
  //   }
  // }

  getViewList(){
    if (this.componentId){
      this.viewService.getSystemViewList(this.componentId).subscribe(result=>{
        this.systemViewList = this.sortViewList(JSON.parse(result));
      });
  
      this.viewService.getUserViewList(this.componentId).subscribe(result => {
        this.userViewList = this.sortViewList(JSON.parse(result));
      });
    }
  }

  sortViewList(list:ViewSummaryItem[]):ViewSummaryItem[]{
    return list.sort((a:ViewSummaryItem,b:ViewSummaryItem) => { 
      if(a.ViewOrder > b.ViewOrder){
        return 1;
      }else if(a.ViewOrder < b.ViewOrder){
        return -1;
      }else{
        return 0;
      }
     });
  }

  onClickMenu(action:Action){
    this.menuService.selectMenuCardMenuAction(this.menuId, action.ActionName).subscribe(result => {
      this.menuSelectedChanged.emit(result);
    });
  }

  SelectedViewChanged(event, view: string) {
    this.viewSelectedChanged.emit(event);
    this.view.currentView = view;
  }

  ngOnInit() {
    //this.showView = (window.innerWidth) > 992;
    this.getViewList();
  }

  ngOnDestroy(){
    if (this.sub) this.sub.unsubscribe();
  }

  ShowToDo(){
    this.showView = true;
    this.closeBtnClicked = false;
    this.showSideBar.emit(true);
  }

  HideToDo(){
    this.showView = false;
    this.closeBtnClicked = true;
    this.showSideBar.emit(false);
  }
}
